// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"711":"22ef44ad","885":"4cea13cd","895":"3ed602a1"}[chunkId] + ".chunk.js";
};